<template>
  <SheetContainer title="局部变速" desc="长按选中文字进行设置，最小0.1，最大2.0">
    <div class="sheet-list">
      <div @click="addSpeed(-5)" class="reduce"><van-icon name="minus" /></div>
      <div class="relative">
        <div class="valuePopup" :style="`left:${0.029*(speedValue-10)}rem`"><span
            class="valueBtn">{{parseInt(speedValue)/100}}</span></div>
        <div class="slider">
          <van-slider v-model="speedValue" :step="5" :min="10" :max="200" />
        </div>

        <ul class="speedList">
          <li v-for="(item) in speedValueList" :key="item" :style="`left:${2.9*(item-0.1)}rem`">{{item}}</li>
        </ul>
      </div>
      <div  @click="addSpeed(5)" class="add"><van-icon name="plus" color="#333" /></div>

    </div>
    <div class="btn"><span  :class="['sheet-item',removable?'checked':'']"
        @click="onSelect">确定</span> <span :class="['sheet-item',removable?'removable':'remove']" @click="onRemoveClick">恢复默认</span></div>
  </SheetContainer>
</template>
<style lang='less' scoped>
li {
  display: inline-block;
}

.add,
.reduce {
  color: #333;
  width: 40px;
 outline: #FFFFFF;
}
.add{
  
  // line-height: 185px;
  // margin-top: 75px;
  // transform: translateY(-50%);
  .van-icon{
    margin-top:66px ;
    font-size: 44px;
    font-weight: 1000;
  }
}
.sheet-list{
  display: flex;
  justify-content: space-between;
  // align-items: center;
}
.reduce{
  .van-icon{
    margin-top:66px ;
    font-size: 44px;
    font-weight: 1000;
  }
  
}

.relative{
  position: relative;
}
.sheet-list {
  position: relative;
  overflow: hidden;

  .valuePopup {
    position: absolute;
    transform: translate(-50%);
    margin-bottom: 30px;
    width: 96px;
    text-align: center;
    margin-top: 10px;
    height: 44px;
    background: #FFFFFF;
    box-shadow: 0px 3px 14px 0px rgba(130, 183, 205, 0.56);
    border-radius: 22px;
    font-size: 28px;
    font-family:'HarmonyOS_Sans_SC_Medium';
    color: #515B75;
    line-height: 40px;
  }

  .speedList {
    width: 550px;
    position: relative;
    margin-top: 20px;
    height: 100px;

    li {
      // left: 10%;
      transform: translate(-50%);
      position: absolute;
      font-size: 24px;
      font-family: 'HarmonyOS_Sans_SC';
      font-weight: 400;
      color: #999999;
      line-height: 33px;
    }

  }

  .slider {
    width: 550px;
    margin-top: 85px;
  }
  &.remove{
    background: #f4f4f4;
    border-color: #f4f4f4;
    color: #b8b8b8;
  }
  &.checked{
    background: #3583fb;
    color: #ffffff;
    border-color: #3583fb;
  }
}
.removable {
    background: #dceafe;
    border-color: #dceafe;
    color: #333333;
  }

.btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .sheet-item {
    text-align: center;
    line-height: 64px;
    display: block;
    width: 320px;
    height: 64px;
    border-radius: 10px;
    margin-right: 0px;
  }
}
</style>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import { toast } from "@/utils/util";
import $ from "jquery";
import { customCollectEvent } from '@/utils/collect';
// import { log } from 'console';
export default {
  props: {
    value: {
      // 选中值信息
      type: String,
      default: "",
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
  },
  components: {
    SheetContainer,
  },
  data() {
    return {
      speedValueList: [0.1,0.25,0.5,0.75,'1.0',1.25,1.5,1.75,'2.0'], // 预置的重读选项
      speedValue: 100,
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
    };
  },

  computed: {
    removable() {
      return this.value;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
          if(this.value&&parseFloat(this.value)>=0.1&&parseFloat(this.value)<=2.0){
            this.speedValue = parseInt(parseFloat(this.value)*100)
          }
      },
    },
  },
  methods: {
    // 校验选中是否合法

    isValid() {
      if (this.selection.el) {
        if ($(this.selection.el).attr("data-type") !== "localSpeed") {
          toast("请选择需要设置的字符");
          return false;
        }
        return true;
      }
      if (!$(this.selection.el).attr("data-speedhover") &&!this.selection.rangeText || !this.selection.rangeText.trim()) {
        toast("请选择需要设置的字符");
        return false;
      }
   
      return true;
    },

    addSpeed(num) {
      if (this.speedValue > 10 && this.speedValue < 200||(this.speedValue==10&&num>0)||(this.speedValue==200&&num<0)) {
        this.speedValue += num
      }
    },
    //插入/修改局部变速
    onSelect() {
      if (!this.isValid()) return;
      // const selected = this.options[index];
      let value = this.speedValue / 100 + ""
      let speedhover = $(this.selection.el).attr("data-speedhover")
      if (speedhover) {
        let effectParam={
          effectName:"localSpeed",
          idName:"speedhover",
          id:speedhover,
          innerEffectName:"speed"
        }
        this.$emit("updateNode",effectParam,{
          speed: value,speedval: value + "x"
        });
      } else {
        this.updateValue(value);
      }

    },
   // 删除重读
   onRemoveClick() {
      if (!this.isValid()) return;
      this.speedValue = 100
      let speedhover = $(this.selection.el).attr("data-speedhover")
      let effectParam={
         effectName:"localSpeed",
          idName:"speedhover",
          id:speedhover,
          innerEffectName:"speed"
        }
      this.$emit("updateNode",effectParam,{},'delete');

        customCollectEvent("editor_speed",{
          value: this.speedValue/100,
        });
    },
    // 更新重读值
    updateValue(newValue) {
      // if (newValue !== this.selectedValue) {
        this.selectedValue = newValue;
        this.$emit("update:value",newValue);
        this.$emit("change",newValue);
        customCollectEvent("editor_speed",{
          value: this.speedValue/100,
        });
        
      // }
    },
  },
};
</script>